import { createStandardAction } from 'typesafe-actions';
import { FeedEventData } from '@tradingblock/types';

export const FEED_CLOSED = `@expiringTokens/feed/closed`;
export const FEED_ERRORED = `@expiringTokens/feed/errored`;
export const FEED_CONNECTED = `@expiringTokens/feed/connected`;
export const feedClosed = createStandardAction(FEED_CLOSED)<FeedEventData>();
export const feedErrored = createStandardAction(FEED_ERRORED)<FeedEventData>();
export const feedConnected = createStandardAction(FEED_CONNECTED)();

export const ExpiringTokensFeedActions = {
  expiringTokensFeedClosed: createStandardAction(FEED_CLOSED)<FeedEventData>(),
  expiringTokensFeedErrored: createStandardAction(FEED_ERRORED)<FeedEventData>(),
  expiringTokensFeedConnected: createStandardAction(FEED_CONNECTED)(),
};
